import { LoadingTerminal, LoadingGrid } from "../ui/LoadingState";
import "./Timeline.css";

export default function Timeline({ entries = [], loading = false }) {
  const formatDate = (dateString) => {
    if (!dateString) return "";
    
    // Expected format: YYYY-MM or YYYY or YYYY-MM-DD
    const parts = dateString.split("-");
    
    if (parts.length === 3) {
      // Full date: YYYY-MM-DD
      const date = new Date(dateString);
      return date.toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });
    } else if (parts.length === 2) {
      // Month and year: YYYY-MM
      const date = new Date(parts[0], parts[1] - 1);
      return date.toLocaleDateString("en-US", { year: "numeric", month: "long" });
    } else if (parts.length === 1) {
      // Year only: YYYY
      return parts[0];
    }
    
    return dateString;
  };

  if (loading) {
    return (
      <section id="timeline" className="timeline timeline--loading">
        <LoadingTerminal 
          title="timeline.load"
          lines={[
            { variant: "headline" },
            { variant: "title" },
            { variant: "text" },
          ]}
          meta="3 entries"
        />
      </section>
    );
  }

  const latestId = (() => {
    if (!entries || entries.length < 2) return null;
    const dated = entries.filter((entry) => entry.sort_date);
    if (dated.length === 0) return entries[entries.length - 1]?.id ?? null;
    return dated.reduce((a, b) => (b.sort_date > a.sort_date ? b : a))?.id ?? null;
  })();

  const jumpToLatest = () => {
    document
      .getElementById("timeline-latest")
      ?.scrollIntoView({ behavior: "smooth", block: "center" });
  };

  return (
    <section id="timeline" className="timeline">
      <header className="timeline__header">
        <h2 className="section-title">Timeline</h2>
        <p className="timeline__subtitle">milestones &amp; moments</p>
        {latestId && (
          <button type="button" className="timeline__jump" onClick={jumpToLatest}>
            jump to latest <span aria-hidden="true">↓</span>
          </button>
        )}
      </header>

      <div className="timeline__entries">
        {entries && entries.length > 0 ? (
          entries.map((entry, index) => (
            <div
              key={entry.id || index}
              id={entry.id === latestId ? "timeline-latest" : undefined}
              className={`timeline__entry ${entry.id === latestId ? "timeline__entry--latest" : ""}`}
            >
              <div className="timeline__date">
                <span className="timeline__date-label">{formatDate(entry.date)}</span>
                {entry.id === latestId && <span className="timeline__latest">latest</span>}
              </div>
              <div className="timeline__connector">
                <div className="timeline__dot"></div>
              </div>
              <div className="timeline__content">
                {entry.title && <h3 className="timeline__entry-title">{entry.title}</h3>}
                <p className="timeline__entry-text">{entry.description}</p>
              </div>
            </div>
          ))
        ) : (
          <div className="timeline__empty">
            <p>no timeline entries yet</p>
          </div>
        )}
      </div>
    </section>
  );
}
